import { PropsWithChildren } from 'react';

import {
  NetworkContextProvider,
  NetworkContextProviderProps,
} from 'context/network';
import {
  AppLayoutContextProvider,
  AppLayoutContextProviderProps,
} from 'context/appLayoutContent';
import { AlertDialogContextProvider } from 'context/alertDialog';
import { ReCaptchaContextProvider } from 'context/recaptcha/recaptcha';

type Props = PropsWithChildren &
  NetworkContextProviderProps &
  AppLayoutContextProviderProps;

export type ContextProvidersProps = Props;

export const ContextProviders = (props: Props) => {
  const { network, appLayoutContent, children } = props;

  return (
    <ReCaptchaContextProvider>
      <NetworkContextProvider network={network}>
        <AppLayoutContextProvider appLayoutContent={appLayoutContent}>
          <AlertDialogContextProvider>
            <ReCaptchaContextProvider>{children}</ReCaptchaContextProvider>
          </AlertDialogContextProvider>
        </AppLayoutContextProvider>
      </NetworkContextProvider>
    </ReCaptchaContextProvider>
  );
};
